/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { forwardRef } from "react";

import type { ThemeType } from "../../../../../global/emotion";
import { radius, spacing } from "../../../../../global/emotion";
import { animations } from "../../../../../global/emotion/animations";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";

export type SkeletonProps = HallowElementProps<"div">;

const baseStyle: Interpolation<ThemeType> = (theme) => ({
  animation: `${animations.pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite`,
  backgroundColor: theme.semanticColors.neutralsLowest,
  borderRadius: radius.m,
  height: spacing.full,
  width: spacing.full,
});

export const Skeleton = forwardRef<any, SkeletonProps>((props, ref) => (
  <div ref={ref} css={baseStyle} {...props} />
));
